import { IRoom } from "@eventr/common";
import { useEffect, useMemo, useState } from "react";
import { useBoundStore } from "state/bound.store";
import { useShallow } from "zustand/react/shallow";
import { useRocketChatContext } from "feat/rocketchat/rocketChatProvider";
import { RocketChannel } from "state/rocketchat/rocketchat.interface";

/** A section item's chat channel (matched by object_id) and its live RocketChat room. */
export function useChannelForSectionItem(_id: string): {
  channel: RocketChannel | undefined;
  channelRoom: IRoom | undefined;
} {
  const rocketchannels = useBoundStore(useShallow((s) => s.rocketchannels[s.selectedItinID]));
  const { userRooms } = useRocketChatContext();
  const [channel, setChannel] = useState<RocketChannel | undefined>();

  useEffect(() => {
    setChannel(rocketchannels?.find((c) => c.object_id === _id));
  }, [rocketchannels, _id]);

  const channelRoom = useMemo(
    () => (channel && userRooms ? userRooms.find((room) => room._id === channel.channel_id) : undefined),
    [channel, userRooms],
  );

  return { channel, channelRoom };
}
